import React, { useState, useEffect } from 'react';
import intro from '@/assets/app/images/main/intro.mp4';
import skipBtn from '@/assets/app/images/main/skip_btn.png';
import startBtn from '@/assets/app/images/main/start_btn.png';

// 로컬 스토리지에 저장할 데이터 구조 정의
interface VideoStatus {
  expiry: number; // 만료 타임스탬프 (ms)
}

const STORAGE_KEY = 'intro_video_status';
interface Props {
  setShowIntro: Function;
}

const IntroVideo: React.FC<Props> = ({ setShowIntro }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const checkVisibility = (): void => {
      const storedData = localStorage.getItem(STORAGE_KEY);
      const now = new Date().getTime();

      if (storedData) {
        try {
          const { expiry }: VideoStatus = JSON.parse(storedData);
          // 만료 시간이 지났을 때만 영상을 보여줌
          if (now > expiry) {
            setIsVisible(true);
          } else {
            setShowIntro(false);
          }
        } catch (e) {
          // JSON 파싱 에러 대비 (데이터가 깨진 경우 등)
          setIsVisible(true);
        }
      } else {
        // 데이터가 아예 없으면 처음 접속한 유저
        setIsVisible(true);
      }
    };

    checkVisibility();
  }, []);

  // 오늘 하루 보지 않기 처리
  const handleHideForADay = (): void => {
    const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const status: VideoStatus = { expiry: expiryTime };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(status));
    setIsVisible(false);
  };

  // 그냥 닫기 (다음에 또 보임)
  const handleClose = (): void => {
    setIsVisible(false);
    setShowIntro(false);
  };

  if (!isVisible) return null;

  return (
    <div style={containerStyle}>
      <div style={{ position: 'absolute', width: 80, top: 10, right: 20 }}>
        {/* <button onClick={handleHideForADay} style={subButtonStyle}>
          오늘 하루 보지 않기
        </button> */}
        <img src={skipBtn} onClick={handleClose} />
      </div>

      <video autoPlay muted playsInline loop onEnded={handleClose} style={videoStyle}>
        <source src={intro} type="video/mp4" />
      </video>
      <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', bottom: 40 }}>
        <img src={startBtn} style={{ width: '90%' }} onClick={handleClose} />
      </div>
    </div>
  );
};

// 스타일 타입 정의 (CSSProperties 활용)
const containerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: '#000',
  zIndex: 9999,
};

const videoStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const buttonGroupStyle: React.CSSProperties = {
  position: 'absolute',
  top: '20px',
  right: '20px',
  display: 'flex',
  gap: '10px',
  zIndex: 10000,
};

const mainButtonStyle: React.CSSProperties = {
  /* 스킵 버튼 스타일 */
};
const subButtonStyle: React.CSSProperties = {
  /* 하루 안 보기 스타일 */
};

export default IntroVideo;
